// vg-binding: P7.D-17
//
// apps/vendor/src/features/products/variants/ColorImageGroup.tsx
//
// Per-color image group editor. Wave 8 ships URL-input flavour — file
// upload integration lands with the catalog file pipeline (Wave 8
// import + storage). The matrix shares image URLs across all sizes of
// the same color (image groups).

import { useTranslation } from '../../../lib/i18n/index.js';

interface Props {
  color: string;
  urls: string[];
  onChange: (urls: string[]) => void;
}

export function ColorImageGroup({ color, urls, onChange }: Props): JSX.Element {
  const { t } = useTranslation('products');
  return (
    <div
      data-testid={`color-image-group-${color}`}
      className="flex flex-col gap-1"
    >
      <p className="text-xs font-medium text-pw-text">{color}</p>
      {urls.map((u, i) => (
        <div key={i} className="flex items-center gap-1">
          <input
            type="url"
            value={u}
            onChange={(e) => {
              const next = urls.slice();
              next[i] = e.target.value;
              onChange(next);
            }}
            placeholder={t('variants.imagePlaceholder')}
            className="h-7 flex-1 rounded border border-pw-border bg-pw-bg px-2 text-xs focus:border-pw-primary focus:outline-none"
          />
          <button
            type="button"
            data-testid={`color-image-remove-${color}-${i}`}
            onClick={() => onChange(urls.filter((_v, idx) => idx !== i))}
            className="rounded px-1 text-xs text-pw-text-muted hover:text-red-700"
          >
            ✕
          </button>
        </div>
      ))}
      <button
        type="button"
        data-testid={`color-image-add-${color}`}
        onClick={() => onChange([...urls, ''])}
        className="self-start rounded border border-dashed border-pw-border px-2 py-0.5 text-xs text-pw-text-muted hover:text-pw-text"
      >
        {t('variants.addImage')}
      </button>
    </div>
  );
}

export default ColorImageGroup;
